export const TEST_IDS = {
  intro: {
    signInButton: "intro_sign_in_button",
    skipButton: "intro_skip_button",
  },
  login: {
    emailInput: "login_email_input",
    passwordInput: "login_password_input",
    signInButton: "login_sign_in_button",
    useEmailButton: "login_use_email_button",
    registerButton: "login_register_button",
    qrCode: "login_qr_code",
  },
  register: {
    emailInput: "register_email_input",
    passwordInput: "register_password_input",
    firstNameInput: "register_first_name_input",
    lastNameInput: "register_last_name_input",
    createAccountButton: "register_create_account_button",
  },
  profile: {
    item: (index: number) => `profile_item_${index}`,
    createTile: "profile_create_tile",
    nameInput: "profile_create_name_input",
    tintPreview: "profile_tint_preview",
    tintPrevious: "profile_tint_previous",
    tintNext: "profile_tint_next",
    saveButton: "profile_create_save_button",
    editButton: "profile_edit_button",
    deleteButton: "profile_delete_button",
  },
} as const;
